// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app__header":"App_app__header__IGRZL","app__footer":"App_app__footer__Wca2p","app__main":"App_app__main__3iiSw"};